// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"602":"f161112e","771":"f161112e"}[chunkId] + ".chunk.css";
};